export default __webpack_public_path__ + "6d933291ae2e252d625cc7589030f878.png";